// extracted by mini-css-extract-plugin
module.exports = {"wvfxlf7":"wvfxlf7","p1szcqmo":"p1szcqmo","move1-p1szcqmo":"move1-p1szcqmo"};